
const enNZ = {
	"overlappingManifestErrorMsg": "Unable to create overlapping manifests.",
	"week": "Week",
	"day": "Day",
	"threeDays": "3 Days",
	"specialInstructions": "Special Instructions"
};

export { enNZ };